import React, { createRef, useState } from 'react';
import { Form, Button, Input, Select, Image } from 'antd';
import { useNavigate } from 'react-router-dom';
import MainTable from './MainTable';
import image2 from '../assets/image2.jpeg';
import image4 from '../assets/image4.jpeg';
import image3 from '../assets/image3.jpeg';
import image5 from '../assets/image5.jpeg';

import { useMediaQuery } from 'react-responsive';

const overlayStyle = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  fontSize: '27px',
  width: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  color: '#fff',
  padding: '10px',
  textAlign: 'center',
};

const RequestAssetDataForm = () => {
  const formRef = createRef();
  const { Option } = Select;
  const [value, setValues] = useState('');
  const navigate = useNavigate();
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });

  const onFinish = (values) => {
    setValues(values);
    formRef.current?.resetFields();
  };
  return (
    <>
      {value ? (
        <div style={{ overflow: 'auto' }}>
          <MainTable setValues={setValues} value={value} />
        </div>
      ) : (
        <>
          <div
            style={{
              display: !isTabletOrMobile ? 'flex' : 'grid',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <div
              onClick={() => navigate('/edit-requests')}
              style={{ margin: '20px' }}
            >
              {image3 && (
                <div style={{ position: 'relative', cursor: 'pointer' }}>
                  <Image
                    width={'300px'}
                    preview={false}
                    src={image3}
                    alt='Uploaded'
                  />
                  <div style={overlayStyle}>طلب نقل عهدة</div>
                </div>
              )}
            </div>
            <div
              style={{ margin: '20px' }}
              onClick={() => navigate('/delete-requests')}
            >
              {image2 && (
                <div style={{ position: 'relative', cursor: 'pointer' }}>
                  <Image
                    preview={false}
                    width={'300px'}
                    src={image2}
                    alt='Uploaded'
                  />
                  <div style={overlayStyle}>طلب الاسقاط</div>
                </div>
              )}
            </div>
          </div>
          <div
            style={{
              display: !isTabletOrMobile ? 'flex' : 'grid',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <div
              style={{ margin: '20px' }}
              onClick={() => navigate('/search-assets')}
            >
              {image4 && (
                <div style={{ position: 'relative', cursor: 'pointer' }}>
                  <Image
                    width={'300px'}
                    preview={false}
                    src={image4}
                    alt='Uploaded'
                  />
                  <div style={overlayStyle}>استعلام</div>
                </div>
              )}
            </div>
            <div
              style={{ margin: '20px' }}
              onClick={() => navigate('/request-assets')}
            >
              {image5 && (
                <div style={{ position: 'relative', cursor: 'pointer' }}>
                  <Image
                    width={'300px'}
                    preview={false}
                    src={image5}
                    alt='Uploaded'
                  />
                  <div style={overlayStyle}>ادخال بيانات عهدة جديدة</div>
                </div>
              )}
            </div>
          </div>
          <Form
            name='basic'
            ref={formRef}
            layout='vertical'
            style={{ textAlign: 'center', display: 'none' }}
            initialValues={{ remember: false }}
            onFinish={onFinish}
            labelCol={{
              sm: {
                span: 16,
                offset: 8,
              },
            }}
            wrapperCol={{
              span: 24,
              sm: {
                span: 8,
                offset: 8,
              },
            }}
            autoComplete='off'
          >
            <Form.Item label='ابحث عن طريق' name='Selected'>
              <Select>
                <Option value={'EmployeeId'}>Employee ID</Option>
                <Option value={'Serial'}>Serial Number</Option>
              </Select>
            </Form.Item>
            <Form.Item
              label='ادخل البيانات'
              name='text'
              rules={[{ required: true, message: 'Required!' }]}
            >
              <Input />
            </Form.Item>

            <div style={{ textAlign: 'center' }}>
              <Button
                style={{ borderRadius: '5px', width: '150px' }}
                type='primary'
                htmlType='submit'
                size={'large'}
              >
                استعلام
              </Button>
            </div>
          </Form>
        </>
      )}
    </>
  );
};

export default RequestAssetDataForm;
